"use client";

import React, {useState} from "react";
import NFLink from "app/components/NFLink/NFLink";
import {getEntityUrl} from "provider/magento/utilities";
import {Loader} from "../Loader/Loader";
import {usePhrase} from "../../i18n";
import ProductCard from "../ProductCard/ProductCard";
const CategoryProductView = ({children, paginatedProducts,cols=3, category,title,store, storeCode, _t}) => {


    const t = usePhrase(_t);

    const[productView, setProductView] = useState('grid');


    return <>
        <div className={'flex justify-between items-start mb-3 lg:mb-6 lg:border-b lg:border-[#d8d8d9] lg:pb-6'}>
            <div className={'flex items-center'}>
                <h1 className="text-2xl font-bold">{category ? category?.name : title}</h1>
            </div>

            <div className={'hidden md:flex md:justify-end'}>
{/*                <div>
                    <NFSelect name={'view_mode'} value={productView} prefix={t('View:')} onChange={v => setProductView(v.value)} options={[
                        {value: 'grid', label: <div className={'flex items-center'}><ViewGridIcon className={'h-5 w-5 mr-1 '}/><span>{t('grid')}</span></div>},
                        {value: 'list', label: <div className={'flex items-center'}><ViewListIcon className={'h-5 w-5 mr-1 '}/><span>{t('list')}</span></div>},
                    ]}/>
                </div>*/}
                {/*  <div>
                            <NFSelect name={'sort_mode'} prefix={{t('Order by:')}} options={[
                                {value: 'relevance', label: t('relevance')},
                                {value: 'name', label: t('name')},
                            ]}/>
                        </div>*/}
            </div>
        </div>

        {category && category.childrenData.length > 0 &&
            <div className={'flex lg:hidden space-x-2 mb-3'}>
                {category.childrenData.map(c => <div key={'cat_subcat_' + c.id} className={''}>
                    <NFLink storeCode={storeCode} href={c?.url}
                        className={'rounded bg-[#d8d8d9] py-2 px-3'}>

                        <span className={'text-sm capitalize'}>{c.name}</span>

                    </NFLink>
                </div>)}
            </div>}


        {!paginatedProducts && <Loader/>}

        {paginatedProducts && <>
            <div className={`flex flex-col lg:grid ${cols===3 ? 'lg:grid-cols-3' : 'lg:grid-cols-4'} lg:gap-2  `}>
                {paginatedProducts?.items.length > 0 && paginatedProducts.items.map(p =>
                    <ProductCard key={'pc_' + p.id} {...p} store={store} storeCode={storeCode} category={category} view={productView} imagePriority={true} _t={_t}/>
                )}
            </div>


        </>}

    </>;
    /* {paginatedProducts.items_count > paginatedProducts.items.length && <>
                        <div className={'flex justify-center'}>
                            <Button white className={'w-4/12'}>
                                <span>{t('Load more products')}</span>
                            </Button>
                        </div>
                    </>}*/
}

export default CategoryProductView;